/* file description */
import { Select } from 'antd';
import React, { FC, useEffect } from 'react';
import { useGetTreeData, useSetVal } from './effect';
import { MobileUserSelect } from './MobileUserSelect';
import { MobileSelect } from '../MobileSelect';
import { UserSelectProps } from './type';
import { COLUMN_FROM } from '../../effects/consts';
import memo from '../memo';

export const UserSelect: FC<UserSelectProps> = ({
  FetchAPI,
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  disabled,
  allowClear,
  moduleInfo,
  isMobile,
}) => {
  const { dispatchEvent, destroyEvent } = config.metaStore || {};
  const { treeData } = useGetTreeData({ field, FetchAPI, form, config, columnFrom, onChange, moduleInfo });
  const { selectTree } = useSetVal({ onChange, field, columnFrom, form, treeData, config });

  useEffect(() => {
    const events = [{
      code: field.name,
      name: field.label,
      touchConfig: 'change',
      actionType: 'callback',
      moduleName: moduleInfo.handle,
      fieldName: field.name,
      rowIndex: config.rowIndex,
      fun: (val: any, { type }: any) => {
        const { options = [] } = field?.bizConfig || {};
        const SelectedRef = field?.bizConfig?.userList.find((item: any) => item.userAccount === val);
        if (SelectedRef) {
          // 联动字段
          options.forEach((item: { moduleField: any; linkField: any }) => {
            const values: Record<any, any> = {};
            if (columnFrom === COLUMN_FROM.FORM) {
              if (!(type === 'light' && config?.formValue?.[item.moduleField])) {
                values[item.moduleField] = SelectedRef[item.linkField];
                form.setFieldsValue(values);
              }
            }
            if (columnFrom === COLUMN_FROM.TABLE) {
              if (!(type === 'light' && config?.formValue?.[config.rowIndex]?.[item.moduleField])) {
                const tableKey = config.rowIndex;
                values[tableKey] = {};
                values[tableKey][item.moduleField] = SelectedRef[item.linkField];
                form.setFieldsValue(values);
              }
            }
          });
        }
      },
    }];
    const ids = dispatchEvent?.(events);
    return () => {
      destroyEvent?.(ids);
    };
  }, []);

  if (isMobile) {
    return (
      <MobileSelect
        value={value}
        options={treeData}
        onChange={selectTree}
        disabled={disabled}
        fieldNames={{
          label: 'userName',
          value: 'userAccount',
        }}
      />
    );
  }

  return (
    <>
      <Select
        style={{ width: '100%', minWidth: '100px' }}
        allowClear={allowClear !== false}
        showSearch
        value={value}
        disabled={disabled}
        options={treeData}
        onChange={selectTree}
        optionFilterProp="userName"
        fieldNames={{
          label: 'userName',
          value: 'userAccount',
        }}
      />
    </>
  );
};
export default memo(UserSelect);
